import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ImpersonateUserModal } from "../Dialog/ImpersonateUserModal";
import {
  List,
  ListItem,
  ListItemPrefix,
  Drawer,
  Card
} from "@material-tailwind/react";
import { UserCircleIcon, Cog6ToothIcon } from "@heroicons/react/24/solid";
import {
  HomeIcon,
  AcademicCapIcon,
  UserGroupIcon,
  CalendarDaysIcon,
  ChatBubbleLeftRightIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";

import { Logout } from "../../store/actions/auth.action";

import MeetingIcon from "../../assets/image/Meeting.svg";
import PaymentHistoryIcon from "../../assets/image/PaymentHistory.svg";
import ChangePasswordIcon from "../../assets/image/ChangePassword.svg";
import LogoutIcon from "../../assets/image/Logout.svg";
import ProfileIcon from "../../assets/image/Profile.svg";
import LeaderProfileIcon from "../../assets/image/Step-3.svg";
import { useTranslation } from "react-i18next";

export function MenuBar(props) {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [openImpersonate, setOpenImpersonate] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);

  let isAdmin = false;
  try {
    let userData = currentUser;
    if (typeof userData === "string" && userData.trim() !== "") {
      userData = JSON.parse(userData);
    }
    if (!userData || (!userData.is_staff && !userData.is_superuser)) {
      const stored = localStorage.getItem("userData");
      if (stored) userData = JSON.parse(stored);
    }
    if (userData && (userData.is_staff || userData.is_superuser)) {
      isAdmin = true;
    }
  } catch (e) {
    console.error("Error parsing user data for admin check", e);
  }

  const removeBodyClass = (className) =>
    document.body.classList.remove(className);
  const logout = () => {
    dispatch(Logout());
    localStorage.removeItem("token");
    localStorage.removeItem("mail");
    localStorage.removeItem("userData");
    props.close();
    removeBodyClass("overflow-hidden");
    navigation("/");
  };
  const { t } = useTranslation();

  const navItems = [
    { label: t("header.home"), path: "/", icon: HomeIcon },
    { label: t("header.introduction"), path: "/introduction", icon: HomeIcon },
    { label: t("header.lingo_teacher"), path: "/become-a-leader", icon: AcademicCapIcon },
    { label: t("header.lingo_learner"), path: "/become-a-learner", icon: UserGroupIcon },
    { label: t("header.schedule_meeting"), path: "/schedule-meeting", icon: CalendarDaysIcon },
    { label: t("header.conversation_questions"), path: "/conversation-questions", icon: ChatBubbleLeftRightIcon },
    { label: t("header.our_team"), path: "/our-team", icon: UsersIcon },
  ];

  const handleClickLogin = () => {
    navigation("/login");
  };
  const handleClickRegister = () => {
    navigation("/register");
  };
  const handleClickProfile = () => {
    navigation("/user/profile");
  };
  const handleClickLeaderProfile = () => {
    navigation("/user/leader-profile");
  };
  const handleMeetingList = () => {
    navigation("/user/meetings");
  };
  const handleClickPayment = () => {
    navigation("/user/payment");
  };
  const handleClickChangePassword = () => {
    navigation("/user/changePassword");
  };
  return (
    <>
      <Drawer
        open={props.open}
        onClose={() => {
          props.close();
          removeBodyClass("overflow-hidden");
        }}
        placement="right"
        className="w-[250px] md:w-[350px] bg-[var(--bg)] overflow-scroll"
      >
        <Card
          color="transparent"
          shadow={false}
          className="h-[calc(100vh-2rem)] w-full p-4"
        >
          <List
            onClick={() => {
              removeBodyClass("overflow-hidden");
            }}
          >
            {navItems.map((item) => (
              <ListItem key={item.path} onClick={() => { navigation(item.path); props.close(); }}>
                <ListItemPrefix>
                  <item.icon className="h-5 w-5" />
                </ListItemPrefix>
                {item.label}
              </ListItem>
            ))}
            <hr className="my-2 border-[var(--border)]" />
            {token === null ? (
              <>
                <ListItem onClick={handleClickLogin}>
                  <ListItemPrefix onClick={handleClickLogin}>
                    <Link>
                      <UserCircleIcon className="h-5 w-5" />
                    </Link>
                  </ListItemPrefix>
                  <Link>{t("header.login")}</Link>
                </ListItem>
                <ListItem onClick={handleClickRegister}>
                  <ListItemPrefix onClick={handleClickRegister}>
                    <Link>
                      <Cog6ToothIcon className="h-5 w-5" />
                    </Link>
                  </ListItemPrefix>
                  <Link>{t("header.register")}</Link>
                </ListItem>
              </>
            ) : (
              <>
                <ListItem onClick={handleClickProfile}>
                  <ListItemPrefix onClick={handleClickProfile}>
                    <Link>
                      <img
                        src={ProfileIcon}
                        alt="User profile"
                        className="w-[20px] h-[20px]"
                      />
                    </Link>
                  </ListItemPrefix>
                  <Link>{t("header.profile")}</Link>
                </ListItem>
                <ListItem onClick={handleClickLeaderProfile}>
                  <ListItemPrefix onClick={handleClickLeaderProfile}>
                    <Link>
                      <img
                        src={LeaderProfileIcon}
                        alt="Tutor profile"
                        className="w-[20px] h-[20px]"
                      />
                    </Link>
                  </ListItemPrefix>
                  <Link>{t("header.teacher_profile")}</Link>
                </ListItem>
                <ListItem onClick={handleMeetingList}>
                  <ListItemPrefix onClick={handleMeetingList}>
                    <Link>
                      <img
                        src={MeetingIcon}
                        alt="Meeting"
                        className="w-[20px] h-[20px]"
                      />
                    </Link>
                  </ListItemPrefix>
                  <Link>{t("header.meetings")}</Link>
                </ListItem>
                <ListItem onClick={handleClickPayment}>
                  <ListItemPrefix onClick={handleClickPayment}>
                    <Link>
                      <img
                        src={PaymentHistoryIcon}
                        alt="Payment"
                        className="w-[20px] h-[20px]"
                      />
                    </Link>
                  </ListItemPrefix>
                  <Link>{t("header.payments")}</Link>
                </ListItem>
                <ListItem onClick={handleClickChangePassword}>
                  <ListItemPrefix onClick={handleClickChangePassword}>
                    <Link>
                      <img
                        src={ChangePasswordIcon}
                        alt="Change Password"
                        className="w-[20px] h-[20px]"
                      />
                    </Link>
                  </ListItemPrefix>
                  <Link>{t("header.change_password")}</Link>
                </ListItem>
                {isAdmin && (
                  <ListItem
                    onClick={() => {
                      props.close();
                      removeBodyClass("overflow-hidden");
                      setOpenImpersonate(true);
                    }}
                    className="bg-amber-50 hover:bg-amber-100 text-amber-900 border border-amber-200 my-1 font-semibold"
                  >
                    <ListItemPrefix>
                      <span className="text-base">👤</span>
                    </ListItemPrefix>
                    Impersonate User
                  </ListItem>
                )}
                <ListItem onClick={logout}>
                  <ListItemPrefix>
                    <img
                      src={LogoutIcon}
                      alt="Logout"
                      className="w-[20px] h-[20px]"
                    />
                  </ListItemPrefix>
                  {t("header.logout")}
                </ListItem>
              </>
            )}
          </List>
        </Card>
      </Drawer>
      <ImpersonateUserModal
        open={openImpersonate}
        close={() => setOpenImpersonate(false)}
      />
    </>
  );
}
